import { CommonModule } from '@angular/common'
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
  standalone: true,
  imports: [OptimUiSharedModule, CommonModule],
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() fixed: boolean = false
  @Input() display: string = 'lg'
  @Input() minimized: boolean = false
  @Input() show: boolean = false
  @Output() minimizedChange = new EventEmitter<boolean>()

  ngOnInit() {}

  toggleMinimize() {
    this.minimized = !this.minimized
    this.minimizedChange.emit(this.minimized)
  }
}
